import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconDevicesBlack({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<path d="M13.055 19.84a1.084 1.084 0 1 1-2.168-.002 1.084 1.084 0 0 1 2.168.003zm-.738 0a.346.346 0 0 0-.693 0 .346.346 0 0 0 .693 0" />
			<path d="M17.935 20.593c0 .854-.752 1.533-1.66 1.533H7.533c-.91 0-1.663-.679-1.663-1.533V2.969c0-.854.753-1.53 1.663-1.53h8.744c.907 0 1.66.676 1.66 1.53zm-.738 0V2.969c0-.429-.404-.79-.921-.79H7.532c-.52 0-.924.361-.924.79v17.624c0 .429.404.791.924.791h8.744c.517 0 .92-.362.92-.791z" />
			<path d="M6.239 18.336h11.327a.37.37 0 1 0 0-.738H6.24a.37.37 0 1 0 0 .738zM10.964 3.57h1.81a.37.37 0 1 0 0-.738h-1.81a.37.37 0 1 0 0 .738M6.239 4.976h11.327a.37.37 0 0 0 .37-.372.37.37 0 0 0-.37-.37H6.24a.37.37 0 0 0-.37.37.37.37 0 0 0 .37.372z" />
			<path
				fill="#e42821"
				d="M11.663 9.94a.677.677 0 0 1-.679.679H9.1a.68.68 0 0 1-.678-.679V8.056c0-.376.305-.679.678-.679h1.884c.377 0 .679.303.679.679zm-.738-.06V8.116H9.16V9.88zm4.707.06a.677.677 0 0 1-.678.679h-1.885a.68.68 0 0 1-.678-.679V8.056a.68.68 0 0 1 .678-.679h1.885c.376 0 .678.303.678.679zm-.738-1.824h-1.765V9.88h1.765zm-3.23 5.793a.68.68 0 0 1-.68.679H9.1a.68.68 0 0 1-.678-.679v-1.884c0-.376.305-.679.678-.679h1.885c.376 0 .678.303.678.679zm-.74-1.824H9.16v1.765h1.765zm4.708 1.824a.68.68 0 0 1-.678.679h-1.885a.68.68 0 0 1-.678-.679v-1.884a.68.68 0 0 1 .678-.679h1.885c.376 0 .678.303.678.679zm-.738-1.824h-1.765v1.765h1.765z"
			/>
		</svg>
	);
}
